/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { PageTitle } from "../../../_uLearn/layout/core";
import { Button, Col, Row } from "react-bootstrap";
import { DashboardString, String } from "../../../utils/string";
import StudentImg from "../../../_uLearn/assets/media/st.png";
import TeacherImg from "../../../_uLearn/assets/media/th.png";
import schoolImg from "../../../_uLearn/assets/media/sl.png";
import VendorImg from "../../../_uLearn/assets/media/market.png";
import APICallService from "../../../api/apiCallService";
import { dashBoardEndPoints } from "../../../api/apiEndPoints";
import Loader from "../../../Global/loader";
import SchoolStudent from "./schoolStudent";
import ClassStudent from "./classStudent";
import Vendors from "./vendors";
import RegisterSchool from "./registerSchool";
import VendorSchoolRecently from "./vendorSchoolRecently";
// import { useSocket } from "../../modules/socket/core/Socket";
// import DashboardReport from "../../modals/reports/dashboard-reports";
const DashboardPage: FC = () => {
  const [loading, setLoading] = useState(true);
  const [initData, setInitData] = useState<any>();

  useEffect(() => {
    (async () => {
      setLoading(true);
      await fetchInitData();
      setLoading(false);
    })();
  }, []);
  const fetchInitData = async () => {
    setLoading(true);
    const apiService = new APICallService(dashBoardEndPoints.STATUS_COUNT);
    const response = await apiService.callAPI();
    if (response) {
      setInitData(response);
    }
    setLoading(false);
  };

  return (
    <>
      <Row className="align-items-center">
        <Col xs className="align-self-center mb-5">
          <h1 className="fs-22 fw-bolder mb-0">{DashboardString.dashboard}</h1>
        </Col>
        {loading ? (
          <div className="w-100 d-flex justify-content-center">
            <Loader loading={loading} />
          </div>
        ) : (
          <>
            {" "}
            <Col xs={12} className="mb-7">
              <Row className="g-10">
                <Col xl={3} md={6} sm={4}>
                  <div className="border-r8px bg-cfeoff rounded py-4 px-5 d-flex justify-content-between align-items-center h-90px p-20">
                    <div>
                      <div className="d-flex align-items-center">
                        <div className="fs-22 fw-bolder">
                          {initData?.totalStudent || 0}
                        </div>
                      </div>
                      <div className="fw-500 fs-16">
                        {DashboardString.totalStudent}
                      </div>
                    </div>
                    <div className="bg-white  rounded-circle w-50px h-50px d-flex align-items-center justify-content-center">
                      <img
                        src={StudentImg}
                        style={{ width: "50px", height: "50px" }}
                      />
                    </div>
                  </div>
                </Col>
                <Col xl={3} md={6} sm={4}>
                  <div className="border-r8px bg-ede2fe rounded py-4 px-5 d-flex justify-content-between align-items-center h-90px">
                    <div>
                      <div className="d-flex align-items-center">
                        <div className="fs-22 fw-bolder">
                          {initData?.totalTeacher || 0}
                        </div>
                      </div>
                      <div className="fw-500 fs-16">
                        {DashboardString.totalTeacher}
                      </div>
                    </div>
                    <div className="bg-white  rounded-circle w-50px h-50px d-flex align-items-center justify-content-center">
                      <img
                        src={TeacherImg}
                        style={{ width: "50px", height: "50px" }}
                      />
                    </div>
                  </div>
                </Col>
                <Col xl={3} md={6} sm={4}>
                  <div className="border-r8px bg-fee2d5 rounded py-4 px-5 d-flex justify-content-between align-items-center h-90px">
                    <div>
                      <div className="d-flex align-items-center">
                        <div className="fs-22 fw-bolder">
                          {initData?.totalSchool || 0}
                        </div>
                      </div>
                      <div className="fw-500 fs-16">
                        {DashboardString.totalSchool}
                      </div>
                    </div>
                    <div className="bg-white  rounded-circle w-50px h-50px d-flex align-items-center justify-content-center">
                      <img
                        src={schoolImg}
                        style={{ width: "50px", height: "50px" }}
                      />
                    </div>
                  </div>
                </Col>
                <Col xl={3} md={6} sm={4}>
                  <div className="border-r8px bg-c1f5e9 rounded py-4 px-5 d-flex justify-content-between align-items-center h-90px">
                    <div>
                      <div className="d-flex align-items-center">
                        <div className="fs-22 fw-bolder">
                          {initData?.totalVendor || 0}
                        </div>
                      </div>
                      <div className="fw-500 fs-16">
                        {DashboardString.totalVendor}
                      </div>
                    </div>
                    <div className="bg-white  rounded-circle w-50px h-50px d-flex align-items-center justify-content-center">
                      <img
                        src={VendorImg}
                        style={{ width: "30px", height: "30px" }}
                      />
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
            {/* <Col xs={12} className="mb-2">
              <SchoolStudent />
            </Col> */}
            <Col xs={12} className="mb-2">
              <Vendors />
            </Col>
            <Col xs={12} className="mb-2">
              <ClassStudent />
            </Col>
            <Col xs={12} className="mb-2">
              <RegisterSchool />
            </Col>
            <Col xs={12} className="mb-2">
              <VendorSchoolRecently />
            </Col>
          </>
        )}
      </Row>
    </>
  );
};
const DashboardWrapper: FC = () => {
  const intl = useIntl();
  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({ id: "MENU.DASHBOARD" })}
      </PageTitle>
      <DashboardPage />
    </>
  );
};
export { DashboardWrapper };
